import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-lost-internet',
  templateUrl: './fh-svg-lost-internet.component.html',
  styleUrl: './fh-svg-lost-internet.component.scss'
})
export class FhSvgLostInternetComponent {
  @Input() color: string = '';
}
